import React from 'react';
import PropTypes from 'prop-types';

import { PitchingDecisionTypes } from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.types';

import PlayerMatchup from './PlayerMatchup';

const Decisions = (props) => {

    const {
        data,
        loading,
    } = props;


    const { decisions = {} } = data;

    const {
        winner,
        loser,
        save,
    } = decisions;

    return (
        <>
            <PlayerMatchup
                player={winner}
                loading={loading}
                decision={PitchingDecisionTypes.W}
            />
            <PlayerMatchup
                player={loser}
                loading={loading}
                decision={PitchingDecisionTypes.L}
            />
            <PlayerMatchup
                player={save}
                loading={loading}
                decision={PitchingDecisionTypes.SV}
            />
        </>
    );

};

Decisions.propTypes = {
    decisions: PropTypes.object,
    loading: PropTypes.bool,
};

Decisions.defaultProps = {
    decisions: {},
    loading: false,
};

export default Decisions;
